import { http } from "./http";

export interface Info {
    messageKey: string;
    messageTextType: string;
    textAZE: string;
    textENG: string;
    textRU: string;
    messageImage: string;

};

export const getMessageList = async (): Promise<Info[]> => {
    const  { data } = await http.get<Info[]>(`/bank/get-frond-message`);
    return data;
};
export const getSecretKey = async (): Promise<any> => {
    const { data } = await http.post<any>('/auth/get-secret-word')
    return data
}
export const getSecretKeyVerify = async (request:any): Promise<any> => {
    const { data } = await http.post<any>('/auth/get-secret-word/verify',request)
    return data
}